import { AxiosRequestConfig } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import Lottery from '../../Models/Lottery';
import GetDictionaryResponse from '../Responses/DictionaryResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

import { ChangeOrderDirection } from './FaqsApi';

class LotteriesApi extends AbstractCRMApi {
    public endpoint: string = 'lottery';

    public async getNames(includeSoccerType: boolean = true): Promise<GetDictionaryResponse> {
        return (
            await this.get('/lotteries_short', {
                params: {
                    includeSoccerType,
                },
            })
        ).data;
    }

    public async getSliderData(): Promise<GetDictionaryResponse> {
        return (await this.get('/lotteries_slider')).data;
    }

    public async getAll(page: number = 1, config?: AxiosRequestConfig): Promise<GetPaginatedResponse<Lottery>> {
        const response = await this.get('', {
            ...config,
            params: { ...config?.params, page },
        });

        return AbstractCRMApi.mapPaginatedDataToModel(response.data, Lottery);
    }

    public async setEnable(displaySlug: string, isEnable: boolean): Promise<void> {
        await this.post(`/${displaySlug}/${isEnable ? 'enable' : 'disable'}`);
    }

    public async changeOrder(
        displaySlug: string,
        direction: ChangeOrderDirection,
        doNotSwap: boolean = false
    ): Promise<Lottery> {
        const config = { params: { doNotSwap: doNotSwap ? 1 : undefined } };
        const response = await this.patch(`/${displaySlug}/change_order/${direction}`, null, config);

        return AbstractCRMApi.mapDataToModel(response.data, Lottery);
    }

    public async setPromoted(displaySlug: string, isPromoted: boolean): Promise<void> {
        await this.patch(`/${displaySlug}/promote`, { is_promoted: isPromoted });
    }
}

export default new LotteriesApi();
